var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAccountOrder = function SvgIconAccountOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.999.833 7.916 4.583v9.167L8 19.166.082 14.583V5.416zM2.577 5.898l5.422 3.139 5.422-3.14L7.999 2.76zm-.828 1.446v6.278l5.416 3.136V10.48zm7.083 9.414 5.417-3.136V7.344L8.832 10.48z"
  })));
};
export default SvgIconAccountOrder;